<template>
    <tr class="call-parking-item-table-row" @mouseover="isHover = true" @mouseleave="isHover = false">
        <td class="call-parking-item-table-row-cell">
            <template v-if="isWallboard">{{ item.number }}</template>
        </td>

        <td v-if="!breakpoints.isMobile" class="call-parking-item-table-row-cell">
            <contact
                v-if="item.parked_by_number"
                :number="item.parked_by_number"
                :is-hover="isHover"
            ></contact>

            <span v-else>{{ $t("panel.services.call-parking.incoming-call") }}</span>
        </td>

        <td class="call-parking-item-table-row-cell">
          {{ endInText }}
        </td>

        <td class="call-parking-item-table-row-cell">
            <contact
                :number="item.parked_number"
                :is-hover="isHover"
            ></contact>
        </td>
    </tr>
</template>

<script>

import BaseButton from "../defaults/BaseButton.vue";
import Contact from "../defaults/Contact.vue";
import breakpoints from "../../plugins/breakpoints";

export default {
    name: "CallParkingItemTableRow",
    components: {Contact, BaseButton},
    props: {
        item: {
            type: Object,
            default: {}
        },
        isWallboard: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isHover: false,
            currentTime: this.calcStartCurrentTime(),
            timer: null,
            breakpoints
        }
    },
    created() {
        if (this.currentTime === 0) {
            this.parkTimeIsOver()
        }
    },
    watch: {
        currentTime(value) {
            if (value === 0) {
                this.parkTimeIsOver()
            }
        }
    },
    computed: {
        endInText() {
            const totalMinutes = Math.floor(this.currentTime / 60)

            if (totalMinutes > 0) {
                return `${totalMinutes}m`
            }

            return `${this.currentTime}s`
        }
    },
    mounted() {
        this.startTimer()
    },
    destroyed() {
        this.stopTimer()
    },
    methods: {
        calcStartCurrentTime() {
            return Math.max(0, this.item.park_end_in_seconds - Math.floor((Date.now() - this.item.park_started_at_timestamp) / 1000))
        },

        startTimer() {
            this.timer = setInterval(() => {
                this.currentTime--
            }, 1000)
        },

        stopTimer() {
            clearTimeout(this.timer)
        },

        parkTimeIsOver() {
            this.$emit("park-time-is-over")
            this.stopTimer()
        }
    }
}
</script>

<style scoped>

</style>